export default __webpack_public_path__ + "static/media/go-logo-blue.08e457cd.svg";